import { TDecodedToken } from "./authentication.types";
import { getLocalStorageItem } from "../../hooks/useLocalStorage";
import { auth, AUTH_TOKEN_STORAGE } from "../../services/firebase.service";

/**
 * To support offline mode, bypass the getIdTokenResult when offline, and
 * restored a cached version of the decoded token for redirection
 */
export async function getDecodedAuthToken(forceRefresh?: boolean | undefined) {
  if (window.navigator.onLine) {
    const decodedToken = await auth.currentUser?.getIdTokenResult(forceRefresh);
    return decodedToken as TDecodedToken | undefined;
  } else {
    const token = getLocalStorageItem<{ value: TDecodedToken }>(
      AUTH_TOKEN_STORAGE,
    );
    return Promise.resolve(token?.value);
  }
}
